import { render, staticRenderFns } from "./GvdReferences.vue?vue&type=template&id=5a7c8dec"
import script from "./GvdReferences.vue?vue&type=script&lang=ts"
export * from "./GvdReferences.vue?vue&type=script&lang=ts"
import style0 from "./GvdReferences.vue?vue&type=style&index=0&id=5a7c8dec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports